interface FilterOptions
{
    [index: string]: any
}

export default abstract class AbstractFilter
{
    protected _options: FilterOptions;

    constructor(options?: FilterOptions)
    {
        if (options)
        {
            this._options = options;
        }
    }

    abstract filter(value: any): any;
}